export const CRM_STAGE_ATTRIBUTE_KEY = 'kevoa_crm_stage';
export const CRM_UNASSIGNED_STAGE_ID = 'no-stage';

export const CRM_STAGES = [
  { id: 'entry', value: 'Entrada', labelKey: 'CRM_PIPELINE.STAGES.ENTRY' },
  {
    id: 'first-contact',
    value: 'Primeiro contato',
    labelKey: 'CRM_PIPELINE.STAGES.FIRST_CONTACT',
  },
  {
    id: 'qualification',
    value: 'Qualificação',
    labelKey: 'CRM_PIPELINE.STAGES.QUALIFICATION',
  },
  {
    id: 'proposal',
    value: 'Proposta',
    labelKey: 'CRM_PIPELINE.STAGES.PROPOSAL',
  },
  {
    id: 'negotiation',
    value: 'Negociação',
    labelKey: 'CRM_PIPELINE.STAGES.NEGOTIATION',
  },
  { id: 'won', value: 'Ganho', labelKey: 'CRM_PIPELINE.STAGES.WON' },
  { id: 'lost', value: 'Perdido', labelKey: 'CRM_PIPELINE.STAGES.LOST' },
];

export const CRM_LANES = [
  {
    id: CRM_UNASSIGNED_STAGE_ID,
    value: null,
    labelKey: 'CRM_PIPELINE.STAGES.NO_STAGE',
  },
  ...CRM_STAGES,
];
